import { getBooleanSchema, getStringSchema } from 'src/compass/shared/schemas';
import * as Yup from 'yup';

export const TagSchema = Yup.object().shape({
  name: getStringSchema(50, 'Tag name'),
  isActive: getBooleanSchema('Active'),
  color: Yup.string()
    .matches(/^#[0-9a-fA-F]{6}$/, {
      message: 'Must be a hex color like #RRGGBB.',
      excludeEmptyString: true,
    })
    .nullable(),
});
